module.exports = __webpack_public_path__ + "img/启用.58afa5be.svg";